import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AwazeThemeProvider, } from '@awaze/design-system.components.awaze-theme-provider';
import { GlobalStyle } from './global-style';
export const ComposeWithGlobalStyle = ({ children, brand, }) => (_jsxs(AwazeThemeProvider, { brand: brand, children: [_jsx(GlobalStyle, {}), children] }));
//# sourceMappingURL=compose-with-global-style.js.map